import { GetDealByIdQuery } from '@/lib/graphql/generated/graphql';

export enum ExportStatus {
  Completed = 'completed',
  Created = 'created',
  Error = 'error',
}

export const isExportSettled = (status: string) =>
  status === ExportStatus.Completed || status === ExportStatus.Error;

export interface ExportError {
  step: string;
  code?: string;
  operation?: string;
  documentTitle?: string;
  fileId?: string;
}

export type DealSelectionExportFromQuery = NonNullable<
  GetDealByIdQuery['deal']
>['selectionExports'][number];
